import React from 'react';
import {
  compose,
  setDisplayName,
  withProps,
  defaultProps,
} from 'recompose';
import reactCSS from 'reactcss';
import { H } from '@team-griffin/react-heading-section';
import { FormattedMessage } from 'react-intl';
import CascadingFormattedMessage from '@ux/cascading-formatted-message';
import { TextButton, Size, Against } from '@ux/text-button';
import { ShowWhen, Branch, True, False } from '@ux/render-logic';
import { getStyles } from '@ux/style-utils';
import stylesheet from './Header.stylesheet';
import * as r from 'ramda';
import * as rA from 'ramda-adjunct';

const stylesheetToStyles = r.unary(reactCSS);

export const PureHeader = ({
  theme,
  styles,
  intlNamespace,
  privacyPolicyUrl,
  hasPrivacyPolicy,
  expanded,
}) => (
  <div style={styles.root}>
    <H
      depth={2}
      style={styles.title}
    >
      <FormattedMessage id={`cookie.${intlNamespace}.title`}/>
    </H>

    <p style={styles.text}>
      <Branch test={expanded}>
        <True>
          <CascadingFormattedMessage
            cascade={[
              {
                id: `cookie.${intlNamespace}.settings`,
              },
              {
                id: `cookie.${intlNamespace}.description`,
              },
            ]}
          />
        </True>
        <False>
          <FormattedMessage id={`cookie.${intlNamespace}.description`}/>
        </False>
      </Branch>
      {' '}
      <ShowWhen test={hasPrivacyPolicy}>
        <span style={styles.link}>
          <TextButton
            href={privacyPolicyUrl}
            theme={theme}
            target="_blank"
            against={Against.NEUTRAL}
            size={Size.MD}
          >
            <FormattedMessage id="cookie.privacyPolicy"/>
          </TextButton>
        </span>
      </ShowWhen>
    </p>
  </div>
);

export const enhance = compose(
  setDisplayName('Header'),
  defaultProps({
    expanded: false,
  }),
  withProps((ownerProps) => ({
    styles: getStyles(stylesheet, stylesheetToStyles, ownerProps),
    hasPrivacyPolicy: r.pipe(
      r.prop('privacyPolicyUrl'),
      rA.isNilOrEmpty,
      r.not,
    )(ownerProps),
  })),
);

export default enhance(PureHeader);



// WEBPACK FOOTER //
// ./src/presentation/components/header/Header.js